const FormConfigSqlPage = () => {
  return (
    <div>导出配置</div>
  )
}

export default FormConfigSqlPage